/** マップに同梱しているピン画像（Import の getPinId と一致） */
const PIN_IMAGE_IDS = new Set([
  'food_famires',
  'service_goraku',
  'office',
  'other'
])

export const pinImageUrl = (pinId?: string | null): string => {
  const raw = (pinId && String(pinId).trim()) || 'other'
  const base = PIN_IMAGE_IDS.has(raw) ? raw : 'other'
  return `${window.location.origin}/images/pins/${base}.png`
}

export const fallbackPinImageUrl = (): string => pinImageUrl('other')
